import _ from 'lodash'

// eslint-disable-next-line
export const getAllAddresses = (addressesTable) => {
    const allAddresses = _.get(addressesTable, '_table', []) // Get _table property of table data
        .reduce((acc, table) => [...acc, ..._.get(table, 'tables', [])], []) // Get all tables from _table
        .reduce((acc, table) => [...acc, ..._.get(table, 'rows', [])], []) // Get all rows from tables

    return allAddresses
}
